import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, ArticleDTO } from "../api";
import { useAuth } from "../auth";

function fmt(ts: number) {
  return new Date(ts * 1000).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
}

export default function ArticlesList() {
  const { me, can } = useAuth();
  const navigate = useNavigate();
  const [items, setItems] = useState<ArticleDTO[] | null>(null);
  const [err, setErr] = useState<string | null>(null);
  const [creating, setCreating] = useState(false);

  const load = () => api.listArticles().then(setItems).catch((e) => setErr(e.message));
  useEffect(() => {
    load();
  }, []);

  const create = async () => {
    const title = prompt("Article title?", "Untitled article");
    if (title === null) return;
    setCreating(true);
    try {
      const a = await api.createArticle(title || "Untitled article");
      navigate(`/articles/${a.id}`);
    } catch (e: any) {
      setErr(e.message);
      setCreating(false);
    }
  };

  const remove = async (a: ArticleDTO) => {
    if (!confirm(`Delete "${a.title}"? This cannot be undone.`)) return;
    await api.deleteArticle(a.id);
    load();
  };

  const editorView = can("editor");

  return (
    <div className="page-wrap">
      <div style={{ display: "flex", alignItems: "baseline", gap: 16, marginBottom: 24 }}>
        <h1 style={{ fontFamily: "'Cinzel',serif", fontWeight: 700, fontSize: 30, margin: 0 }}>
          {editorView ? "All Articles" : "My Articles"}
        </h1>
        <button className="btn btn-accent" style={{ marginLeft: "auto" }} disabled={creating} onClick={create}>
          + New article
        </button>
      </div>

      {err && <p style={{ color: "var(--accent)" }}>{err}</p>}
      {!items && !err && <p className="mono" style={{ color: "var(--muted)", fontSize: 12 }}>Loading…</p>}
      {items && items.length === 0 && <p style={{ color: "var(--muted)" }}>No articles yet. Create your first one.</p>}

      {items && items.length > 0 && (
        <div style={{ border: "1px solid var(--rule2)" }}>
          {items.map((a, i) => (
            <div
              key={a.id}
              style={{
                display: "grid",
                gridTemplateColumns: editorView ? "1fr 140px 110px 90px" : "1fr 110px 90px",
                alignItems: "center",
                gap: 12,
                padding: "14px 18px",
                borderTop: i ? "1px solid var(--rule2)" : "none",
                background: i % 2 ? "var(--paper2)" : "var(--paper)",
              }}
            >
              <div>
                <Link to={`/articles/${a.id}`} style={{ fontFamily: "'Zilla Slab',sans-serif", fontWeight: 600, fontSize: 17, color: "var(--ink)" }}>
                  {a.title}
                </Link>
                <div className="mono" style={{ fontSize: 10, color: "var(--muted)", marginTop: 4 }}>
                  {editorView && a.authorName ? `${a.authorName} · ` : ""}updated {fmt(a.updatedAt)}
                </div>
              </div>
              {editorView && (
                <span className="mono" style={{ fontSize: 10.5, color: "var(--muted)" }}>
                  {a.authorSub === me?.sub ? "you" : a.authorName}
                </span>
              )}
              <span
                className="mono"
                style={{
                  fontSize: 10,
                  textTransform: "uppercase",
                  letterSpacing: ".1em",
                  color: a.status === "submitted" ? "var(--accent)" : "var(--muted)",
                }}
              >
                {a.status}
              </span>
              <div style={{ textAlign: "right" }}>
                <button className="miniadd" onClick={() => remove(a)}>
                  delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
